import { useState,useEffect } from "react";
import Pagination from "react-js-pagination";

function PaginationComponent({ activePageProp = 1, itemsCountPerPageProp = 5, totalItemsCountProp = 100, pageRangeDisplayedProp = 5, pageReturnProp }) {
  const [activePage, setActivePage] = useState(activePageProp);

  const [lang, setlang] = useState(localStorage.getItem("i18nextLng"));

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    pageReturnProp(pageNumber);
  };
  useEffect(() => {
    setActivePage(activePageProp);
  }, [activePageProp]);
  return (
    <>
      <Pagination
        activePage={activePage}
        itemsCountPerPage={itemsCountPerPageProp}
        totalItemsCount={totalItemsCountProp}
        pageRangeDisplayed={pageRangeDisplayedProp}
        onChange={handlePageChange}
        linkClass="text-3xl" // 👈 حجم الخط
        itemClass="mx-2"
        firstPageText={
          <div className="w-8 h-8">
            <img src={lang.toLowerCase() !== "ar" ? "/assets/icons/pagination-icons/first_page_FILL.svg" : "/assets/icons/pagination-icons/last_page_FILL.svg"} alt="FileList Page" />
          </div>
        }
        lastPageText={
          <div className="w-8 h-8">
            <img src={lang.toLowerCase() === "ar" ? "/assets/icons/pagination-icons/first_page_FILL.svg" : "/assets/icons/pagination-icons/last_page_FILL.svg"} alt="FileList Page" />
          </div>
        }
        nextPageText={
          <div className="w-5 h-5">
            <img src={lang.toLowerCase() !== "ar" ? "/assets/icons/pagination-icons/arrow_forward.svg" : "/assets/icons/pagination-icons/arrow_back.svg"} alt="FileList Page" />
          </div>
        }
        prevPageText={
          <div className="w-5 h-5">
            <img src={lang.toLowerCase() === "ar" ? "/assets/icons/pagination-icons/arrow_forward.svg" : "/assets/icons/pagination-icons/arrow_back.svg"} alt="FileList Page" />
          </div>
        }
      />
    </>
  );
}

export default PaginationComponent;

// import { useState } from "react";
// import { Pagination } from "antd";

// function PaginationComponent({
//   activePageProp = 1,
//   itemsCountPerPageProp = 5,
//   totalItemsCountProp = 100,
//   pageRangeDisplayedProp = 5,
//   pageReturnProp,
// }) {
//   const [activePage, setActivePage] = useState(activePageProp);
//   const lang = localStorage.getItem("i18nextLng") || "en";

//   const isAr = lang.toLowerCase() === "ar";

//   const handleChange = (page) => {
//     setActivePage(page);
//     pageReturnProp(page);
//   };

//   return (
//     <Pagination
//     className="custom-pagination"
//       current={activePage}
//       defaultCurrent={1}
//       align="center"
//       size="small"
//       pageSize={itemsCountPerPageProp}
//       total={totalItemsCountProp}
//       onChange={handleChange}
//       showSizeChanger={false}       // ✅ اخفاء dropdown تغيير عدد العناصر
//       showQuickJumper={false}       // ✅ اخفاء القفز للصفحة
//       showLessItems                 // ✅ تحسين عرض الأرقام

//       itemRender={(page, type, originalElement) => {
//         // ===== First =====
//         if (type === "first") {
//           return (
//             <div className="w-8 h-8 flex items-center justify-center">
//               <img
//                 src={
//                   !isAr
//                     ? "/assets/icons/pagination-icons/first_page_FILL.svg"
//                     : "/assets/icons/pagination-icons/last_page_FILL.svg"
//                 }
//                 alt="first"
//               />
//             </div>
//           );
//         }

//         // ===== Last =====
//         if (type === "last") {
//           return (
//             <div className="w-8 h-8 flex items-center justify-center">
//               <img
//                 src={
//                   isAr
//                     ? "/assets/icons/pagination-icons/first_page_FILL.svg"
//                     : "/assets/icons/pagination-icons/last_page_FILL.svg"
//                 }
//                 alt="last"
//               />
//             </div>
//           );
//         }

//         // ===== Next =====
//         if (type === "next") {
//           return (
//             <div className="w-5 h-5 flex items-center justify-center">
//               <img
//                 src={
//                   !isAr
//                     ? "/assets/icons/pagination-icons/arrow_forward.svg"
//                     : "/assets/icons/pagination-icons/arrow_back.svg"
//                 }
//                 alt="next"
//               />
//             </div>
//           );
//         }

//         // ===== Prev =====
//         if (type === "prev") {
//           return (
//             <div className="w-5 h-5 flex items-center justify-center">
//               <img
//                 src={
//                   isAr
//                     ? "/assets/icons/pagination-icons/arrow_forward.svg"
//                     : "/assets/icons/pagination-icons/arrow_back.svg"
//                 }
//                 alt="prev"
//               />
//             </div>
//           );
//         }

//         // ===== Numbers =====
//         return (
//           <span className="text-3xl mx-2">
//             {page}
//           </span>
//         );
//       }}
//     />
//   );
// }

// export default PaginationComponent;
